<template>
  <v-overlay :value="loading" :absolute="absolute" :opacity="overlayOpacity" :color="overlayColor" :z-index="overlayZIndex">
    <v-progress-circular indeterminate size="40" color="primary lighten-2"></v-progress-circular>
  </v-overlay>
</template>
<script>
  export default {
    name: 'OverlayPreloader',
    props: ['loading', 'absolute', 'opacity', 'color', 'zIndex'],
    data: () => ({
    }),
      computed: {
          overlayOpacity () {
              return this.opacity || 0.4
          },
          overlayColor () {
              return this.color || null
          },
          overlayZIndex () {
              return this.zIndex || 'auto'
          }
      }
  }
</script>
